// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","layout":"App_layout__Asyut"};